import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ApplicationContextProvider from "@context/ApplicationContext";
import AuthContextProvider from "@context/AuthContext";
import BookSessionContextProvider from "@context/BookSessionContext";
import CheckoutComplimentaryContextProvider from "@context/CheckoutComplimentaryContext";
import MembershipContextProvider from "@context/MembershipContext";
import ProfileContextProvider from "@context/ProfileContext";
import PromoContextProvider from "@context/PromoContext";
import SearchContextProvider from "@context/SearchContext";
import SessionContextProvider from "@context/SessionContext";
import TicketContextProvider from "@context/TicketContext";
import { TicketsProvider } from "@context/TicketsContext";
import UserContextProvider from "@context/UserContext";
import VoucherManagerContextProvider from "@context/VoucherManagerContext";
import AutoLogin from "@components/AutoLogin";
import RouteCollection from "@components/RouteCollection";
import "@components/App.scss";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            retry: 1,
        },
    },
});
const App = () => {

    return (
        <QueryClientProvider client={queryClient}>
            <AuthContextProvider>
                <TicketsProvider>
                    <VoucherManagerContextProvider>
                        <MembershipContextProvider>
                            <UserContextProvider>
                                <PromoContextProvider>
                                    <ProfileContextProvider>
                                        <ApplicationContextProvider>
                                            <SearchContextProvider>
                                                <SessionContextProvider>
                                                    <CheckoutComplimentaryContextProvider>
                                                        <BookSessionContextProvider>
                                                            <TicketContextProvider>
                                                                <AutoLogin>
                                                                    <RouteCollection />
                                                                </AutoLogin>
                                                            </TicketContextProvider>
                                                        </BookSessionContextProvider>
                                                    </CheckoutComplimentaryContextProvider>
                                                </SessionContextProvider>
                                            </SearchContextProvider>
                                        </ApplicationContextProvider>
                                    </ProfileContextProvider>
                                </PromoContextProvider>
                            </UserContextProvider>
                        </MembershipContextProvider>
                    </VoucherManagerContextProvider>
                </TicketsProvider>
            </AuthContextProvider>
        </QueryClientProvider>

    );
};

export default App;
